// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "proposal.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "proposal.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { URLObject } from "./s3";
import { Bool } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { File } from "./s3";
import { TimesheetDepartment } from "./timesheet_department";
import { QuoteLineList } from "./quote";
import { EventPhoto } from "./event";
import { QuoteDocument } from "./quote";
import { Event } from "./event";
import { User } from "./user";
import { Property } from "./property";
import { Document } from "./s3";
import { QuoteLine } from "./quote";
// @generated message type with reflection information, may provide speed optimized methods
class SendProposalReminderRequest$Type extends MessageType {
    constructor() {
        super("SendProposalReminderRequest", [
            { no: 1, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "trigger_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteDocumentId = 0;
        message.triggerKey = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 quote_document_id */ 1:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string trigger_key */ 2:
                    message.triggerKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 quote_document_id = 1; */
        if (message.quoteDocumentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.quoteDocumentId);
        /* string trigger_key = 2; */
        if (message.triggerKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.triggerKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendProposalReminderRequest
 */
export const SendProposalReminderRequest = new SendProposalReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalReminderEvaluation$Type extends MessageType {
    constructor() {
        super("ProposalReminderEvaluation", [
            { no: 1, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "would_send", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "trigger_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "window_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "days_until_expire", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "hours_since_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "customer_viewed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "reminders_sent", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "automated_reminders_sent", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "max_automated_reminders", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "min_window_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteDocumentId = 0;
        message.wouldSend = false;
        message.triggerKey = "";
        message.reason = "";
        message.windowDays = 0;
        message.daysUntilExpire = 0;
        message.hoursSinceSent = 0;
        message.customerViewed = false;
        message.remindersSent = [];
        message.automatedRemindersSent = 0;
        message.maxAutomatedReminders = 0;
        message.minWindowDays = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 quote_document_id */ 1:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* bool would_send */ 2:
                    message.wouldSend = reader.bool();
                    break;
                case /* string trigger_key */ 3:
                    message.triggerKey = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* int32 window_days */ 5:
                    message.windowDays = reader.int32();
                    break;
                case /* int32 days_until_expire */ 6:
                    message.daysUntilExpire = reader.int32();
                    break;
                case /* int32 hours_since_sent */ 7:
                    message.hoursSinceSent = reader.int32();
                    break;
                case /* bool customer_viewed */ 8:
                    message.customerViewed = reader.bool();
                    break;
                case /* repeated string reminders_sent */ 9:
                    message.remindersSent.push(reader.string());
                    break;
                case /* int32 automated_reminders_sent */ 10:
                    message.automatedRemindersSent = reader.int32();
                    break;
                case /* int32 max_automated_reminders */ 11:
                    message.maxAutomatedReminders = reader.int32();
                    break;
                case /* int32 min_window_days */ 12:
                    message.minWindowDays = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 quote_document_id = 1; */
        if (message.quoteDocumentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.quoteDocumentId);
        /* bool would_send = 2; */
        if (message.wouldSend !== false)
            writer.tag(2, WireType.Varint).bool(message.wouldSend);
        /* string trigger_key = 3; */
        if (message.triggerKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.triggerKey);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* int32 window_days = 5; */
        if (message.windowDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.windowDays);
        /* int32 days_until_expire = 6; */
        if (message.daysUntilExpire !== 0)
            writer.tag(6, WireType.Varint).int32(message.daysUntilExpire);
        /* int32 hours_since_sent = 7; */
        if (message.hoursSinceSent !== 0)
            writer.tag(7, WireType.Varint).int32(message.hoursSinceSent);
        /* bool customer_viewed = 8; */
        if (message.customerViewed !== false)
            writer.tag(8, WireType.Varint).bool(message.customerViewed);
        /* repeated string reminders_sent = 9; */
        for (let i = 0; i < message.remindersSent.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.remindersSent[i]);
        /* int32 automated_reminders_sent = 10; */
        if (message.automatedRemindersSent !== 0)
            writer.tag(10, WireType.Varint).int32(message.automatedRemindersSent);
        /* int32 max_automated_reminders = 11; */
        if (message.maxAutomatedReminders !== 0)
            writer.tag(11, WireType.Varint).int32(message.maxAutomatedReminders);
        /* int32 min_window_days = 12; */
        if (message.minWindowDays !== 0)
            writer.tag(12, WireType.Varint).int32(message.minWindowDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalReminderEvaluation
 */
export const ProposalReminderEvaluation = new ProposalReminderEvaluation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalReminderSettings$Type extends MessageType {
    constructor() {
        super("ProposalReminderSettings", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "min_window_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "max_automated_reminders", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.minWindowDays = 0;
        message.maxAutomatedReminders = 0;
        message.createdAt = "";
        message.updatedAt = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 min_window_days */ 2:
                    message.minWindowDays = reader.int32();
                    break;
                case /* int32 max_automated_reminders */ 3:
                    message.maxAutomatedReminders = reader.int32();
                    break;
                case /* string created_at */ 4:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 5:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 min_window_days = 2; */
        if (message.minWindowDays !== 0)
            writer.tag(2, WireType.Varint).int32(message.minWindowDays);
        /* int32 max_automated_reminders = 3; */
        if (message.maxAutomatedReminders !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxAutomatedReminders);
        /* string created_at = 4; */
        if (message.createdAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 5; */
        if (message.updatedAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalReminderSettings
 */
export const ProposalReminderSettings = new ProposalReminderSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalDeclineContext$Type extends MessageType {
    constructor() {
        super("ProposalDeclineContext", [
            { no: 1, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "proposal_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteDocumentId = 0;
        message.proposalLabel = "";
        message.propertyAddress = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 quote_document_id */ 1:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string proposal_label */ 2:
                    message.proposalLabel = reader.string();
                    break;
                case /* string property_address */ 3:
                    message.propertyAddress = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 quote_document_id = 1; */
        if (message.quoteDocumentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.quoteDocumentId);
        /* string proposal_label = 2; */
        if (message.proposalLabel !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.proposalLabel);
        /* string property_address = 3; */
        if (message.propertyAddress !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.propertyAddress);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalDeclineContext
 */
export const ProposalDeclineContext = new ProposalDeclineContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeclineProposalRequest$Type extends MessageType {
    constructor() {
        super("DeclineProposalRequest", [
            { no: 1, name: "token", kind: "message", T: () => TokenProposal },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TokenProposal token */ 1:
                    message.token = TokenProposal.internalBinaryRead(reader, reader.uint32(), options, message.token);
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TokenProposal token = 1; */
        if (message.token)
            TokenProposal.internalBinaryWrite(message.token, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeclineProposalRequest
 */
export const DeclineProposalRequest = new DeclineProposalRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalPdfRequest$Type extends MessageType {
    constructor() {
        super("ProposalPdfRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "signature", kind: "message", T: () => Blob },
            { no: 3, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id = 1 [deprecated = true] */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* Blob signature */ 2:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* int32 quote_document_id */ 3:
                    message.quoteDocumentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* Blob signature = 2; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 quote_document_id = 3; */
        if (message.quoteDocumentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteDocumentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalPdfRequest
 */
export const ProposalPdfRequest = new ProposalPdfRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequest$Type extends MessageType {
    constructor() {
        super("GetRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* int32 quote_document_id */ 2:
                    message.quoteDocumentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* int32 quote_document_id = 2; */
        if (message.quoteDocumentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.quoteDocumentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRequest
 */
export const GetRequest = new GetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRequest$Type extends MessageType {
    constructor() {
        super("UpdateRequest", [
            { no: 1, name: "proposal", kind: "message", T: () => Proposal },
            { no: 2, name: "signature", kind: "message", T: () => Blob },
            { no: 3, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.notify = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Proposal proposal */ 1:
                    message.proposal = Proposal.internalBinaryRead(reader, reader.uint32(), options, message.proposal);
                    break;
                case /* Blob signature */ 2:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* bool notify */ 3:
                    message.notify = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Proposal proposal = 1; */
        if (message.proposal)
            Proposal.internalBinaryWrite(message.proposal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Blob signature = 2; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool notify = 3; */
        if (message.notify !== false)
            writer.tag(3, WireType.Varint).bool(message.notify);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRequest
 */
export const UpdateRequest = new UpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewUpdateRequest$Type extends MessageType {
    constructor() {
        super("NewUpdateRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "signature", kind: "message", T: () => Blob },
            { no: 3, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "quote_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 5, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.notify = false;
        message.quoteLines = [];
        message.quoteDocumentId = 0;
        message.overrideNote = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id = 1 [deprecated = true] */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* Blob signature */ 2:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* bool notify */ 3:
                    message.notify = reader.bool();
                    break;
                case /* repeated QuoteLine quote_lines */ 4:
                    message.quoteLines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 quote_document_id */ 5:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string override_note = 6 [deprecated = true] */ 6:
                    message.overrideNote = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* Blob signature = 2; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool notify = 3; */
        if (message.notify !== false)
            writer.tag(3, WireType.Varint).bool(message.notify);
        /* repeated QuoteLine quote_lines = 4; */
        for (let i = 0; i < message.quoteLines.length; i++)
            QuoteLine.internalBinaryWrite(message.quoteLines[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 quote_document_id = 5; */
        if (message.quoteDocumentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.quoteDocumentId);
        /* string override_note = 6 [deprecated = true]; */
        if (message.overrideNote !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.overrideNote);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NewUpdateRequest
 */
export const NewUpdateRequest = new NewUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Proposal$Type extends MessageType {
    constructor() {
        super("Proposal", [
            { no: 1, name: "document", kind: "message", T: () => Document },
            { no: 2, name: "quote_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 3, name: "property", kind: "message", T: () => Property },
            { no: 4, name: "user", kind: "message", T: () => User },
            { no: 5, name: "event", kind: "message", T: () => Event },
            { no: 6, name: "quote_document", kind: "message", T: () => QuoteDocument },
            { no: 7, name: "prepared_by", kind: "message", T: () => User },
            { no: 8, name: "download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "photos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventPhoto }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.quoteLines = [];
        message.downloadUrl = "";
        message.photos = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Document document */ 1:
                    message.document = Document.internalBinaryRead(reader, reader.uint32(), options, message.document);
                    break;
                case /* repeated QuoteLine quote_lines */ 2:
                    message.quoteLines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* Property property */ 3:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* User user */ 4:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* Event event */ 5:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* QuoteDocument quote_document */ 6:
                    message.quoteDocument = QuoteDocument.internalBinaryRead(reader, reader.uint32(), options, message.quoteDocument);
                    break;
                case /* User prepared_by */ 7:
                    message.preparedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.preparedBy);
                    break;
                case /* string download_url */ 8:
                    message.downloadUrl = reader.string();
                    break;
                case /* repeated EventPhoto photos */ 9:
                    message.photos.push(EventPhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Document document = 1; */
        if (message.document)
            Document.internalBinaryWrite(message.document, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated QuoteLine quote_lines = 2; */
        for (let i = 0; i < message.quoteLines.length; i++)
            QuoteLine.internalBinaryWrite(message.quoteLines[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 3; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* User user = 4; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* Event event = 5; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* QuoteDocument quote_document = 6; */
        if (message.quoteDocument)
            QuoteDocument.internalBinaryWrite(message.quoteDocument, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* User prepared_by = 7; */
        if (message.preparedBy)
            User.internalBinaryWrite(message.preparedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string download_url = 8; */
        if (message.downloadUrl !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.downloadUrl);
        /* repeated EventPhoto photos = 9; */
        for (let i = 0; i < message.photos.length; i++)
            EventPhoto.internalBinaryWrite(message.photos[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Proposal
 */
export const Proposal = new Proposal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Blob$Type extends MessageType {
    constructor() {
        super("Blob", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes data */ 1:
                    message.data = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes data = 1; */
        if (message.data.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.data);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Blob
 */
export const Blob = new Blob$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenProposalData$Type extends MessageType {
    constructor() {
        super("TokenProposalData", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "expiring_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "purpose", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.expiringDate = "";
        message.quoteDocumentId = 0;
        message.purpose = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* string expiring_date */ 2:
                    message.expiringDate = reader.string();
                    break;
                case /* int32 quote_document_id */ 3:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string purpose */ 4:
                    message.purpose = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* string expiring_date = 2; */
        if (message.expiringDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.expiringDate);
        /* int32 quote_document_id = 3; */
        if (message.quoteDocumentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteDocumentId);
        /* string purpose = 4; */
        if (message.purpose !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.purpose);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TokenProposalData
 */
export const TokenProposalData = new TokenProposalData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenProposal$Type extends MessageType {
    constructor() {
        super("TokenProposal", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TokenProposal
 */
export const TokenProposal = new TokenProposal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWithTokenRequest$Type extends MessageType {
    constructor() {
        super("UpdateWithTokenRequest", [
            { no: 1, name: "token", kind: "message", T: () => TokenProposal },
            { no: 2, name: "proposal", kind: "message", T: () => Proposal },
            { no: 3, name: "signature", kind: "message", T: () => Blob },
            { no: 4, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.notify = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TokenProposal token */ 1:
                    message.token = TokenProposal.internalBinaryRead(reader, reader.uint32(), options, message.token);
                    break;
                case /* Proposal proposal */ 2:
                    message.proposal = Proposal.internalBinaryRead(reader, reader.uint32(), options, message.proposal);
                    break;
                case /* Blob signature */ 3:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* bool notify */ 4:
                    message.notify = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TokenProposal token = 1; */
        if (message.token)
            TokenProposal.internalBinaryWrite(message.token, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* Proposal proposal = 2; */
        if (message.proposal)
            Proposal.internalBinaryWrite(message.proposal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* Blob signature = 3; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool notify = 4; */
        if (message.notify !== false)
            writer.tag(4, WireType.Varint).bool(message.notify);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateWithTokenRequest
 */
export const UpdateWithTokenRequest = new UpdateWithTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewUpdateWithTokenRequest$Type extends MessageType {
    constructor() {
        super("NewUpdateWithTokenRequest", [
            { no: 1, name: "token", kind: "message", T: () => TokenProposal },
            { no: 2, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "signature", kind: "message", T: () => Blob },
            { no: 4, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "quote_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 6, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.notify = false;
        message.quoteLines = [];
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* TokenProposal token */ 1:
                    message.token = TokenProposal.internalBinaryRead(reader, reader.uint32(), options, message.token);
                    break;
                case /* int32 job_id = 2 [deprecated = true] */ 2:
                    message.jobId = reader.int32();
                    break;
                case /* Blob signature */ 3:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* bool notify */ 4:
                    message.notify = reader.bool();
                    break;
                case /* repeated QuoteLine quote_lines */ 5:
                    message.quoteLines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 quote_document_id */ 6:
                    message.quoteDocumentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* TokenProposal token = 1; */
        if (message.token)
            TokenProposal.internalBinaryWrite(message.token, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 job_id = 2 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(2, WireType.Varint).int32(message.jobId);
        /* Blob signature = 3; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool notify = 4; */
        if (message.notify !== false)
            writer.tag(4, WireType.Varint).bool(message.notify);
        /* repeated QuoteLine quote_lines = 5; */
        for (let i = 0; i < message.quoteLines.length; i++)
            QuoteLine.internalBinaryWrite(message.quoteLines[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 quote_document_id = 6; */
        if (message.quoteDocumentId !== 0)
            writer.tag(6, WireType.Varint).int32(message.quoteDocumentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NewUpdateWithTokenRequest
 */
export const NewUpdateWithTokenRequest = new NewUpdateWithTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SendProposalDocumentRequest$Type extends MessageType {
    constructor() {
        super("SendProposalDocumentRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "customer_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "document_filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "cc_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "expiring_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.propertyId = 0;
        message.userId = 0;
        message.customerEmail = "";
        message.customerName = "";
        message.propertyAddress = "";
        message.documentFilename = "";
        message.ccEmails = [];
        message.expiringDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* int32 property_id */ 2:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string customer_email */ 4:
                    message.customerEmail = reader.string();
                    break;
                case /* string customer_name */ 5:
                    message.customerName = reader.string();
                    break;
                case /* string property_address */ 6:
                    message.propertyAddress = reader.string();
                    break;
                case /* string document_filename */ 7:
                    message.documentFilename = reader.string();
                    break;
                case /* repeated string cc_emails */ 8:
                    message.ccEmails.push(reader.string());
                    break;
                case /* string expiring_date */ 9:
                    message.expiringDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* int32 property_id = 2; */
        if (message.propertyId !== 0)
            writer.tag(2, WireType.Varint).int32(message.propertyId);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string customer_email = 4; */
        if (message.customerEmail !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerEmail);
        /* string customer_name = 5; */
        if (message.customerName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.customerName);
        /* string property_address = 6; */
        if (message.propertyAddress !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.propertyAddress);
        /* string document_filename = 7; */
        if (message.documentFilename !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.documentFilename);
        /* repeated string cc_emails = 8; */
        for (let i = 0; i < message.ccEmails.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.ccEmails[i]);
        /* string expiring_date = 9; */
        if (message.expiringDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.expiringDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SendProposalDocumentRequest
 */
export const SendProposalDocumentRequest = new SendProposalDocumentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewSendProposalDocumentRequest$Type extends MessageType {
    constructor() {
        super("NewSendProposalDocumentRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "cc_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "overrideEvent", kind: "message", T: () => Event }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.ccEmails = [];
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id = 1 [deprecated = true] */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* repeated string cc_emails */ 2:
                    message.ccEmails.push(reader.string());
                    break;
                case /* int32 quote_document_id */ 3:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* Event overrideEvent */ 4:
                    message.overrideEvent = Event.internalBinaryRead(reader, reader.uint32(), options, message.overrideEvent);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* repeated string cc_emails = 2; */
        for (let i = 0; i < message.ccEmails.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.ccEmails[i]);
        /* int32 quote_document_id = 3; */
        if (message.quoteDocumentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.quoteDocumentId);
        /* Event overrideEvent = 4; */
        if (message.overrideEvent)
            Event.internalBinaryWrite(message.overrideEvent, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NewSendProposalDocumentRequest
 */
export const NewSendProposalDocumentRequest = new NewSendProposalDocumentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewGetRequest$Type extends MessageType {
    constructor() {
        super("NewGetRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.quoteDocumentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id = 1 [deprecated = true] */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* int32 quote_document_id */ 2:
                    message.quoteDocumentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* int32 quote_document_id = 2; */
        if (message.quoteDocumentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.quoteDocumentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NewGetRequest
 */
export const NewGetRequest = new NewGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NewUpdateWithoutTokenRequest$Type extends MessageType {
    constructor() {
        super("NewUpdateWithoutTokenRequest", [
            { no: 1, name: "job_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "signature", kind: "message", T: () => Blob },
            { no: 3, name: "notify", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "quote_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuoteLine },
            { no: 5, name: "quote_document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "override_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobId = 0;
        message.notify = false;
        message.quoteLines = [];
        message.quoteDocumentId = 0;
        message.overrideNote = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_id = 1 [deprecated = true] */ 1:
                    message.jobId = reader.int32();
                    break;
                case /* Blob signature */ 2:
                    message.signature = Blob.internalBinaryRead(reader, reader.uint32(), options, message.signature);
                    break;
                case /* bool notify */ 3:
                    message.notify = reader.bool();
                    break;
                case /* repeated QuoteLine quote_lines */ 4:
                    message.quoteLines.push(QuoteLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 quote_document_id */ 5:
                    message.quoteDocumentId = reader.int32();
                    break;
                case /* string override_note = 6 [deprecated = true] */ 6:
                    message.overrideNote = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_id = 1 [deprecated = true]; */
        if (message.jobId !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobId);
        /* Blob signature = 2; */
        if (message.signature)
            Blob.internalBinaryWrite(message.signature, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool notify = 3; */
        if (message.notify !== false)
            writer.tag(3, WireType.Varint).bool(message.notify);
        /* repeated QuoteLine quote_lines = 4; */
        for (let i = 0; i < message.quoteLines.length; i++)
            QuoteLine.internalBinaryWrite(message.quoteLines[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 quote_document_id = 5; */
        if (message.quoteDocumentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.quoteDocumentId);
        /* string override_note = 6 [deprecated = true]; */
        if (message.overrideNote !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.overrideNote);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NewUpdateWithoutTokenRequest
 */
export const NewUpdateWithoutTokenRequest = new NewUpdateWithoutTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataProposal$Type extends MessageType {
    constructor() {
        super("DataProposal", [
            { no: 1, name: "event", kind: "message", T: () => Event },
            { no: 2, name: "quote_line_list", kind: "message", T: () => QuoteLineList },
            { no: 3, name: "quote_doc", kind: "message", T: () => QuoteDocument },
            { no: 4, name: "customer", kind: "message", T: () => User },
            { no: 5, name: "prepared_by", kind: "message", T: () => User },
            { no: 6, name: "department", kind: "message", T: () => TimesheetDepartment },
            { no: 7, name: "photos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => File },
            { no: 8, name: "discount", kind: "message", T: () => Discount },
            { no: 9, name: "property", kind: "message", T: () => Property },
            { no: 10, name: "event_photos", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EventPhoto }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.photos = [];
        message.eventPhotos = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Event event */ 1:
                    message.event = Event.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* QuoteLineList quote_line_list */ 2:
                    message.quoteLineList = QuoteLineList.internalBinaryRead(reader, reader.uint32(), options, message.quoteLineList);
                    break;
                case /* QuoteDocument quote_doc */ 3:
                    message.quoteDoc = QuoteDocument.internalBinaryRead(reader, reader.uint32(), options, message.quoteDoc);
                    break;
                case /* User customer */ 4:
                    message.customer = User.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* User prepared_by */ 5:
                    message.preparedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.preparedBy);
                    break;
                case /* TimesheetDepartment department */ 6:
                    message.department = TimesheetDepartment.internalBinaryRead(reader, reader.uint32(), options, message.department);
                    break;
                case /* repeated File photos */ 7:
                    message.photos.push(File.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* Discount discount */ 8:
                    message.discount = Discount.internalBinaryRead(reader, reader.uint32(), options, message.discount);
                    break;
                case /* Property property */ 9:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* repeated EventPhoto event_photos */ 10:
                    message.eventPhotos.push(EventPhoto.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Event event = 1; */
        if (message.event)
            Event.internalBinaryWrite(message.event, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* QuoteLineList quote_line_list = 2; */
        if (message.quoteLineList)
            QuoteLineList.internalBinaryWrite(message.quoteLineList, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* QuoteDocument quote_doc = 3; */
        if (message.quoteDoc)
            QuoteDocument.internalBinaryWrite(message.quoteDoc, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* User customer = 4; */
        if (message.customer)
            User.internalBinaryWrite(message.customer, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* User prepared_by = 5; */
        if (message.preparedBy)
            User.internalBinaryWrite(message.preparedBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* TimesheetDepartment department = 6; */
        if (message.department)
            TimesheetDepartment.internalBinaryWrite(message.department, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated File photos = 7; */
        for (let i = 0; i < message.photos.length; i++)
            File.internalBinaryWrite(message.photos[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* Discount discount = 8; */
        if (message.discount)
            Discount.internalBinaryWrite(message.discount, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 9; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated EventPhoto event_photos = 10; */
        for (let i = 0; i < message.eventPhotos.length; i++)
            EventPhoto.internalBinaryWrite(message.eventPhotos[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DataProposal
 */
export const DataProposal = new DataProposal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Discount$Type extends MessageType {
    constructor() {
        super("Discount", [
            { no: 1, name: "discount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "discountcost", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.discount = "";
        message.discountcost = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string discount */ 1:
                    message.discount = reader.string();
                    break;
                case /* string discountcost */ 2:
                    message.discountcost = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string discount = 1; */
        if (message.discount !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.discount);
        /* string discountcost = 2; */
        if (message.discountcost !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.discountcost);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Discount
 */
export const Discount = new Discount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeForm$Type extends MessageType {
    constructor() {
        super("ProposalIntakeForm", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "technician_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "problem_summary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "why_it_failed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "parts_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "labor_complexity", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "requires_team_lift", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "labor_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "additional_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "submitted_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "tight_space_or_unusual_dimensions", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "assigned_admin_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "proposal_intake_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "return_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "closed_out", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 27, name: "closed_out_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "closed_out_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "closed_out_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.eventId = 0;
        message.technicianUserId = 0;
        message.problemSummary = "";
        message.whyItFailed = "";
        message.partsNeeded = "";
        message.laborComplexity = "";
        message.requiresTeamLift = false;
        message.laborNotes = "";
        message.additionalNotes = "";
        message.status = "";
        message.submittedAt = "";
        message.createdAt = "";
        message.updatedAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.idList = "";
        message.tightSpaceOrUnusualDimensions = false;
        message.assignedAdminUserId = 0;
        message.eventIdList = "";
        message.proposalIntakeTypeId = 0;
        message.returnEventId = 0;
        message.closedOut = false;
        message.closedOutAt = "";
        message.closedOutByUserId = 0;
        message.closedOutNote = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 event_id */ 2:
                    message.eventId = reader.int32();
                    break;
                case /* int32 technician_user_id */ 3:
                    message.technicianUserId = reader.int32();
                    break;
                case /* string problem_summary */ 4:
                    message.problemSummary = reader.string();
                    break;
                case /* string why_it_failed */ 5:
                    message.whyItFailed = reader.string();
                    break;
                case /* string parts_needed */ 6:
                    message.partsNeeded = reader.string();
                    break;
                case /* string labor_complexity */ 7:
                    message.laborComplexity = reader.string();
                    break;
                case /* bool requires_team_lift */ 8:
                    message.requiresTeamLift = reader.bool();
                    break;
                case /* string labor_notes */ 9:
                    message.laborNotes = reader.string();
                    break;
                case /* string additional_notes */ 10:
                    message.additionalNotes = reader.string();
                    break;
                case /* string status */ 11:
                    message.status = reader.string();
                    break;
                case /* string submitted_at */ 12:
                    message.submittedAt = reader.string();
                    break;
                case /* string created_at */ 13:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 14:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated string field_mask */ 15:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 16:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 19:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string id_list */ 20:
                    message.idList = reader.string();
                    break;
                case /* bool tight_space_or_unusual_dimensions */ 21:
                    message.tightSpaceOrUnusualDimensions = reader.bool();
                    break;
                case /* int32 assigned_admin_user_id */ 22:
                    message.assignedAdminUserId = reader.int32();
                    break;
                case /* string event_id_list */ 23:
                    message.eventIdList = reader.string();
                    break;
                case /* int32 proposal_intake_type_id */ 24:
                    message.proposalIntakeTypeId = reader.int32();
                    break;
                case /* int32 return_event_id */ 25:
                    message.returnEventId = reader.int32();
                    break;
                case /* bool closed_out */ 26:
                    message.closedOut = reader.bool();
                    break;
                case /* string closed_out_at */ 27:
                    message.closedOutAt = reader.string();
                    break;
                case /* int32 closed_out_by_user_id */ 28:
                    message.closedOutByUserId = reader.int32();
                    break;
                case /* string closed_out_note */ 29:
                    message.closedOutNote = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 event_id = 2; */
        if (message.eventId !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventId);
        /* int32 technician_user_id = 3; */
        if (message.technicianUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.technicianUserId);
        /* string problem_summary = 4; */
        if (message.problemSummary !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.problemSummary);
        /* string why_it_failed = 5; */
        if (message.whyItFailed !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.whyItFailed);
        /* string parts_needed = 6; */
        if (message.partsNeeded !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.partsNeeded);
        /* string labor_complexity = 7; */
        if (message.laborComplexity !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.laborComplexity);
        /* bool requires_team_lift = 8; */
        if (message.requiresTeamLift !== false)
            writer.tag(8, WireType.Varint).bool(message.requiresTeamLift);
        /* string labor_notes = 9; */
        if (message.laborNotes !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.laborNotes);
        /* string additional_notes = 10; */
        if (message.additionalNotes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.additionalNotes);
        /* string status = 11; */
        if (message.status !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.status);
        /* string submitted_at = 12; */
        if (message.submittedAt !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.submittedAt);
        /* string created_at = 13; */
        if (message.createdAt !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 14; */
        if (message.updatedAt !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated string field_mask = 15; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 16; */
        if (message.pageNumber !== 0)
            writer.tag(16, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 19; */
        if (message.withoutLimit !== false)
            writer.tag(19, WireType.Varint).bool(message.withoutLimit);
        /* string id_list = 20; */
        if (message.idList !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.idList);
        /* bool tight_space_or_unusual_dimensions = 21; */
        if (message.tightSpaceOrUnusualDimensions !== false)
            writer.tag(21, WireType.Varint).bool(message.tightSpaceOrUnusualDimensions);
        /* int32 assigned_admin_user_id = 22; */
        if (message.assignedAdminUserId !== 0)
            writer.tag(22, WireType.Varint).int32(message.assignedAdminUserId);
        /* string event_id_list = 23; */
        if (message.eventIdList !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.eventIdList);
        /* int32 proposal_intake_type_id = 24; */
        if (message.proposalIntakeTypeId !== 0)
            writer.tag(24, WireType.Varint).int32(message.proposalIntakeTypeId);
        /* int32 return_event_id = 25; */
        if (message.returnEventId !== 0)
            writer.tag(25, WireType.Varint).int32(message.returnEventId);
        /* bool closed_out = 26; */
        if (message.closedOut !== false)
            writer.tag(26, WireType.Varint).bool(message.closedOut);
        /* string closed_out_at = 27; */
        if (message.closedOutAt !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.closedOutAt);
        /* int32 closed_out_by_user_id = 28; */
        if (message.closedOutByUserId !== 0)
            writer.tag(28, WireType.Varint).int32(message.closedOutByUserId);
        /* string closed_out_note = 29; */
        if (message.closedOutNote !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.closedOutNote);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeForm
 */
export const ProposalIntakeForm = new ProposalIntakeForm$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeFormList$Type extends MessageType {
    constructor() {
        super("ProposalIntakeFormList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProposalIntakeForm },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProposalIntakeForm results */ 1:
                    message.results.push(ProposalIntakeForm.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProposalIntakeForm results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProposalIntakeForm.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeFormList
 */
export const ProposalIntakeFormList = new ProposalIntakeFormList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchProposalIntakeReq$Type extends MessageType {
    constructor() {
        super("SearchProposalIntakeReq", [
            { no: 1, name: "proposal_intake_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.proposalIntakeId = 0;
        message.serviceItemId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 proposal_intake_id */ 1:
                    message.proposalIntakeId = reader.int32();
                    break;
                case /* int32 service_item_id */ 2:
                    message.serviceItemId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 proposal_intake_id = 1; */
        if (message.proposalIntakeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.proposalIntakeId);
        /* int32 service_item_id = 2; */
        if (message.serviceItemId !== 0)
            writer.tag(2, WireType.Varint).int32(message.serviceItemId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchProposalIntakeReq
 */
export const SearchProposalIntakeReq = new SearchProposalIntakeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeSystem$Type extends MessageType {
    constructor() {
        super("ProposalIntakeSystem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "proposal_intake_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "service_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "problem_summary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "why_it_failed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "labor_hours_lead", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "labor_hours_second", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "labor_hours_helper", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 15, name: "oem_parts_required", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "crane_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "repair_urgency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "equipment_required", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "building_height_ft", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 21, name: "distance_from_roof_edge_ft", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 22, name: "setup_location_photo_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 23, name: "oem_parts_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "ah_data_tag_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "ah_wide_shot_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "condenser_data_tag_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "condenser_wide_shot_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "failure_photo_file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "additional_photo_file_ids", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "linked_diagnosis_memo_ids", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "sale_sheet_schema", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "sale_sheet_data", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "proposal_intake_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.proposalIntakeId = 0;
        message.serviceItemId = 0;
        message.createdAt = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.problemSummary = "";
        message.whyItFailed = "";
        message.laborHoursLead = 0;
        message.laborHoursSecond = 0;
        message.laborHoursHelper = 0;
        message.oemPartsRequired = "";
        message.craneNeeded = "";
        message.repairUrgency = "";
        message.equipmentRequired = "";
        message.notes = "";
        message.buildingHeightFt = 0;
        message.distanceFromRoofEdgeFt = 0;
        message.setupLocationPhotoFileId = 0;
        message.oemPartsList = "";
        message.ahDataTagFileId = 0;
        message.ahWideShotFileId = 0;
        message.condenserDataTagFileId = 0;
        message.condenserWideShotFileId = 0;
        message.failurePhotoFileId = 0;
        message.additionalPhotoFileIds = "";
        message.linkedDiagnosisMemoIds = "";
        message.saleSheetSchema = "";
        message.saleSheetData = "";
        message.proposalIntakeIdList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 proposal_intake_id */ 2:
                    message.proposalIntakeId = reader.int32();
                    break;
                case /* int32 service_item_id */ 3:
                    message.serviceItemId = reader.int32();
                    break;
                case /* string created_at */ 4:
                    message.createdAt = reader.string();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 6:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 7:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 8:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 9:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string problem_summary */ 10:
                    message.problemSummary = reader.string();
                    break;
                case /* string why_it_failed */ 11:
                    message.whyItFailed = reader.string();
                    break;
                case /* float labor_hours_lead */ 12:
                    message.laborHoursLead = reader.float();
                    break;
                case /* float labor_hours_second */ 13:
                    message.laborHoursSecond = reader.float();
                    break;
                case /* float labor_hours_helper */ 14:
                    message.laborHoursHelper = reader.float();
                    break;
                case /* string oem_parts_required */ 15:
                    message.oemPartsRequired = reader.string();
                    break;
                case /* string crane_needed */ 16:
                    message.craneNeeded = reader.string();
                    break;
                case /* string repair_urgency */ 17:
                    message.repairUrgency = reader.string();
                    break;
                case /* string equipment_required */ 18:
                    message.equipmentRequired = reader.string();
                    break;
                case /* string notes */ 19:
                    message.notes = reader.string();
                    break;
                case /* float building_height_ft */ 20:
                    message.buildingHeightFt = reader.float();
                    break;
                case /* float distance_from_roof_edge_ft */ 21:
                    message.distanceFromRoofEdgeFt = reader.float();
                    break;
                case /* int32 setup_location_photo_file_id */ 22:
                    message.setupLocationPhotoFileId = reader.int32();
                    break;
                case /* string oem_parts_list */ 23:
                    message.oemPartsList = reader.string();
                    break;
                case /* int32 ah_data_tag_file_id */ 24:
                    message.ahDataTagFileId = reader.int32();
                    break;
                case /* int32 ah_wide_shot_file_id */ 25:
                    message.ahWideShotFileId = reader.int32();
                    break;
                case /* int32 condenser_data_tag_file_id */ 26:
                    message.condenserDataTagFileId = reader.int32();
                    break;
                case /* int32 condenser_wide_shot_file_id */ 27:
                    message.condenserWideShotFileId = reader.int32();
                    break;
                case /* int32 failure_photo_file_id */ 28:
                    message.failurePhotoFileId = reader.int32();
                    break;
                case /* string additional_photo_file_ids */ 29:
                    message.additionalPhotoFileIds = reader.string();
                    break;
                case /* string linked_diagnosis_memo_ids */ 30:
                    message.linkedDiagnosisMemoIds = reader.string();
                    break;
                case /* string sale_sheet_schema */ 31:
                    message.saleSheetSchema = reader.string();
                    break;
                case /* string sale_sheet_data */ 32:
                    message.saleSheetData = reader.string();
                    break;
                case /* string proposal_intake_id_list */ 33:
                    message.proposalIntakeIdList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 proposal_intake_id = 2; */
        if (message.proposalIntakeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.proposalIntakeId);
        /* int32 service_item_id = 3; */
        if (message.serviceItemId !== 0)
            writer.tag(3, WireType.Varint).int32(message.serviceItemId);
        /* string created_at = 4; */
        if (message.createdAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdAt);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 6; */
        if (message.pageNumber !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 7; */
        if (message.orderBy !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 8; */
        if (message.orderDir !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 9; */
        if (message.withoutLimit !== false)
            writer.tag(9, WireType.Varint).bool(message.withoutLimit);
        /* string problem_summary = 10; */
        if (message.problemSummary !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.problemSummary);
        /* string why_it_failed = 11; */
        if (message.whyItFailed !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.whyItFailed);
        /* float labor_hours_lead = 12; */
        if (message.laborHoursLead !== 0)
            writer.tag(12, WireType.Bit32).float(message.laborHoursLead);
        /* float labor_hours_second = 13; */
        if (message.laborHoursSecond !== 0)
            writer.tag(13, WireType.Bit32).float(message.laborHoursSecond);
        /* float labor_hours_helper = 14; */
        if (message.laborHoursHelper !== 0)
            writer.tag(14, WireType.Bit32).float(message.laborHoursHelper);
        /* string oem_parts_required = 15; */
        if (message.oemPartsRequired !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.oemPartsRequired);
        /* string crane_needed = 16; */
        if (message.craneNeeded !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.craneNeeded);
        /* string repair_urgency = 17; */
        if (message.repairUrgency !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.repairUrgency);
        /* string equipment_required = 18; */
        if (message.equipmentRequired !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.equipmentRequired);
        /* string notes = 19; */
        if (message.notes !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.notes);
        /* float building_height_ft = 20; */
        if (message.buildingHeightFt !== 0)
            writer.tag(20, WireType.Bit32).float(message.buildingHeightFt);
        /* float distance_from_roof_edge_ft = 21; */
        if (message.distanceFromRoofEdgeFt !== 0)
            writer.tag(21, WireType.Bit32).float(message.distanceFromRoofEdgeFt);
        /* int32 setup_location_photo_file_id = 22; */
        if (message.setupLocationPhotoFileId !== 0)
            writer.tag(22, WireType.Varint).int32(message.setupLocationPhotoFileId);
        /* string oem_parts_list = 23; */
        if (message.oemPartsList !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.oemPartsList);
        /* int32 ah_data_tag_file_id = 24; */
        if (message.ahDataTagFileId !== 0)
            writer.tag(24, WireType.Varint).int32(message.ahDataTagFileId);
        /* int32 ah_wide_shot_file_id = 25; */
        if (message.ahWideShotFileId !== 0)
            writer.tag(25, WireType.Varint).int32(message.ahWideShotFileId);
        /* int32 condenser_data_tag_file_id = 26; */
        if (message.condenserDataTagFileId !== 0)
            writer.tag(26, WireType.Varint).int32(message.condenserDataTagFileId);
        /* int32 condenser_wide_shot_file_id = 27; */
        if (message.condenserWideShotFileId !== 0)
            writer.tag(27, WireType.Varint).int32(message.condenserWideShotFileId);
        /* int32 failure_photo_file_id = 28; */
        if (message.failurePhotoFileId !== 0)
            writer.tag(28, WireType.Varint).int32(message.failurePhotoFileId);
        /* string additional_photo_file_ids = 29; */
        if (message.additionalPhotoFileIds !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.additionalPhotoFileIds);
        /* string linked_diagnosis_memo_ids = 30; */
        if (message.linkedDiagnosisMemoIds !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.linkedDiagnosisMemoIds);
        /* string sale_sheet_schema = 31; */
        if (message.saleSheetSchema !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.saleSheetSchema);
        /* string sale_sheet_data = 32; */
        if (message.saleSheetData !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.saleSheetData);
        /* string proposal_intake_id_list = 33; */
        if (message.proposalIntakeIdList !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.proposalIntakeIdList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeSystem
 */
export const ProposalIntakeSystem = new ProposalIntakeSystem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeSystemList$Type extends MessageType {
    constructor() {
        super("ProposalIntakeSystemList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProposalIntakeSystem },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProposalIntakeSystem results */ 1:
                    message.results.push(ProposalIntakeSystem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProposalIntakeSystem results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProposalIntakeSystem.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeSystemList
 */
export const ProposalIntakeSystemList = new ProposalIntakeSystemList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeType$Type extends MessageType {
    constructor() {
        super("ProposalIntakeType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.isActive = false;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        message.idList = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool is_active */ 3:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 5:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 6:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 7:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string id_list */ 9:
                    message.idList = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool is_active = 3; */
        if (message.isActive !== false)
            writer.tag(3, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 5; */
        if (message.pageNumber !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 6; */
        if (message.orderBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 7; */
        if (message.orderDir !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        /* string id_list = 9; */
        if (message.idList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.idList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeType
 */
export const ProposalIntakeType = new ProposalIntakeType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProposalIntakeTypeList$Type extends MessageType {
    constructor() {
        super("ProposalIntakeTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProposalIntakeType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProposalIntakeType results */ 1:
                    message.results.push(ProposalIntakeType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProposalIntakeType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ProposalIntakeType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProposalIntakeTypeList
 */
export const ProposalIntakeTypeList = new ProposalIntakeTypeList$Type();
/**
 * @generated ServiceType for protobuf service ProposalService
 */
export const ProposalService = new ServiceType("ProposalService", [
    { name: "Get", options: {}, I: GetRequest, O: Proposal },
    { name: "Update", options: {}, I: UpdateRequest, O: Proposal },
    { name: "CreateToken", options: {}, I: TokenProposalData, O: TokenProposal },
    { name: "GetWithToken", options: {}, I: TokenProposal, O: Proposal },
    { name: "UpdateWithToken", options: {}, I: UpdateWithTokenRequest, O: Proposal },
    { name: "SendProposalDocument", options: {}, I: SendProposalDocumentRequest, O: Bool },
    { name: "NewUpdate", options: {}, I: NewUpdateRequest, O: Proposal },
    { name: "NewUpdateWithToken", options: {}, I: NewUpdateWithTokenRequest, O: Proposal },
    { name: "NewUpdateWithoutToken", options: {}, I: NewUpdateWithoutTokenRequest, O: Proposal },
    { name: "NewSendProposalDocument", options: {}, I: NewSendProposalDocumentRequest, O: Bool },
    { name: "CreateProposalPdf", options: {}, I: ProposalPdfRequest, O: URLObject },
    { name: "NewGet", options: {}, I: NewGetRequest, O: Proposal },
    { name: "FetchProposalData", options: {}, I: NewGetRequest, O: DataProposal },
    { name: "CreateProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "GetProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "BatchGetProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeFormList },
    { name: "UpdateProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "DeleteProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: Empty },
    { name: "SearchProposalIntake", options: {}, I: SearchProposalIntakeReq, O: ProposalIntakeFormList },
    { name: "SubmitProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "CloseOutProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "ReopenProposalIntakeForm", options: {}, I: ProposalIntakeForm, O: ProposalIntakeForm },
    { name: "CreateProposalIntakeSystem", options: {}, I: ProposalIntakeSystem, O: ProposalIntakeSystem },
    { name: "GetProposalIntakeSystem", options: {}, I: ProposalIntakeSystem, O: ProposalIntakeSystem },
    { name: "BatchGetProposalIntakeSystem", options: {}, I: ProposalIntakeSystem, O: ProposalIntakeSystemList },
    { name: "UpdateProposalIntakeSystem", options: {}, I: ProposalIntakeSystem, O: ProposalIntakeSystem },
    { name: "DeleteProposalIntakeSystem", options: {}, I: ProposalIntakeSystem, O: Empty },
    { name: "GetProposalIntakeType", options: {}, I: ProposalIntakeType, O: ProposalIntakeType },
    { name: "BatchGetProposalIntakeType", options: {}, I: ProposalIntakeType, O: ProposalIntakeTypeList },
    { name: "GetProposalDeclineContext", options: {}, I: TokenProposal, O: ProposalDeclineContext },
    { name: "DeclineProposalWithToken", options: {}, I: DeclineProposalRequest, O: Bool },
    { name: "SendProposalReminder", options: {}, I: SendProposalReminderRequest, O: Bool },
    { name: "EvaluateProposalReminder", options: {}, I: SendProposalReminderRequest, O: ProposalReminderEvaluation },
    { name: "GetProposalReminderSettings", options: {}, I: ProposalReminderSettings, O: ProposalReminderSettings },
    { name: "UpdateProposalReminderSettings", options: {}, I: ProposalReminderSettings, O: ProposalReminderSettings }
]);
